import { Navigate, Route, Routes } from "react-router-dom";

import PortalDashboard from "./screens/Dashboard";
import PortalProjects from "./screens/Projects";
import PortalTickets from "./screens/Tickets";

/**
 * پرتال مشتری — همان چیدمان و همان سایدبار پنل، با منوی خودش.
 *
 * هدر، سوییچر فضای کاری، منوی پروفایل و کلید تم همه از `layout` می‌آیند تا
 * پرتال شکل یک محصول دوم پیدا نکند؛ چیزی که فرق می‌کند فقط آیتم‌های منو و
 * صفحه‌هاست: مشتری نه پروژه می‌سازد، نه تسک دارد، نه به تنظیمات سازمان می‌رسد.
 */
const Portal = () => (
  <Routes>
    <Route path="/portal/dashboard" element={<PortalDashboard />} />
    <Route path="/portal/projects" element={<PortalProjects />} />
    <Route path="/portal/tickets" element={<PortalTickets />} />
    <Route path="*" element={<Navigate to="/portal/dashboard" replace />} />
  </Routes>
);

export default Portal;
